module.exports = __webpack_public_path__ + "static/media/image-primary.59844d9e.svg";